/* eslint-disable */
import React, {Component} from "react";

import {Button, dialog, Input, message, Modal, notification, Tab} from "@posco/posco-ui-react";
import {mesAutobind} from "@posco/posco-shared";

import profileImg01 from "../../static/img/menu/profile_img_male01.png";
import profileImg02 from "../../static/img/menu/profile_img_female01.png";
import profileImg03 from "../../static/img/menu/profile_img_male02.png";
import profileImg04 from "../../static/img/menu/profile_img_female02.png";
import checkIcon from "../../static/img/menu/circle_check.png";
import {Common} from "@plm/o10-share-front";


@mesAutobind
class o10g014112View extends Component {
  constructor(props) {
    super(props);
    this.uploadInputRef = React.createRef();
  }

  componentDidMount() {
    this.setState({isPoscoUser: Common.PotalUtil.getStorageItem("Posco.auth.userInfo").isPoscoUser === "Y"});
    this.init();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.userInfo !== this.props.userInfo) {
      this.init();
    }
  }

  async handleChangeUploadFile(event) {
    console.log("event", event.target.files);

    const formData = new FormData();
    formData.append("file", event.target.files[0]);

    const result = await this.props.onProfileImgUpload(formData);
    //이미지 업로드 성공시
    if (result.status === 200) {
      //userInfo 재로드
      this.props.onUserInfoFind();
    }
  }

  onTabChange(e, data) {
    console.log("data", data);
    this.setState({activeIndex: data.activeIndex});
  }

  async onUserInfoChange() {
    if (!this.props.userInfo || !this.props.userInfo.smrtNoteUserId) {
      return console.log("유저정보없음");
    }
    const param = {
      gcsCompCode: Common.PotalUtil.getStorageItem("gcsCompCode"),
      smrtNoteUserId: this.state.smrtNoteUserId,
      workTelephone: this.state.workTelephone,
      emailAddress: this.state.emailAddress,
      password: this.state.password
    };
    if (this.state.newPassword) param.newPassword = this.state.newPassword;
    if (this.state.checkPassword) param.checkPassword = this.state.checkPassword;

    console.log("param", param);
    let errorMessage = "";

    if (!param.password) errorMessage += "현재 비밀번호를 입력해 주세요\n";

    if (param.password && (param.password === param.newPassword)) errorMessage += "현재비밀번호와 신규 비밀번호가 같습니다.\n";


    if (param.newPassword) {
      const pwLength = /^(?=.{8,16})/;
      const Regex1 = /^(?=.*\d)/;
      const Regex2 = /^(?=.*[a-z])/;
      const Regex3 = /^(?=.*[A-Z])/;
      const Regex4 = /^(?=.*[~!@#$%^&*<>/?])/;
      const RegexArray = [];
      const Regex5 = /(\w)\1{2,}/;

      if (!pwLength.test(param.newPassword)) errorMessage += "신규비밀번호는 8자리이상 16자리 이하여아합니다.\n";

      if (!Regex1.test(param.newPassword)) RegexArray.push("숫자 미포함");
      if (!Regex2.test(param.newPassword)) RegexArray.push("영소문자 미포함");
      if (!Regex3.test(param.newPassword)) RegexArray.push("영대문자 미포함");
      if (!Regex4.test(param.newPassword)) RegexArray.push("특수문자 미포함");
      if (RegexArray.length > 1) {
        errorMessage += "신규비밀번호 형식이 맞지 않습니다.\n";
        errorMessage += `(${RegexArray.toString()})\n`;
      }

      if (Regex5.test(param.newPassword)) errorMessage += "3자리 이상 같은 숫자나 문자 연속 사용 불가.\n";
      if (param.newPassword.includes(this.state.smrtNoteUserId)
        || param.newPassword.includes(Common.PotalUtil.getStorageItem("Posco.auth.userInfo").employeeNumber)
        || param.newPassword.includes(this.state.workTelephone.split("-")[1])
        || param.newPassword.includes(this.state.workTelephone.split("-")[2])
      ) {
        errorMessage += "직번, ID, 전화번호 사용불가.\n";
      }
    }

    if (param.newPassword !== param.checkPassword) errorMessage += "신규 비밀번호 확인이 일치하지않습니다.\n";

    //이메일
    if (!param.emailAddress.match(/[\w\-\.]+\@[\w\-\.]+/g)) errorMessage += "이메일 형식이 맞지 않습니다.\n";

    //전화번호
    if (!param.workTelephone.match(/\d{2,3}-\d{3,4}-\d{4}/g)) errorMessage += "전화번호 형식이 맞지 않습니다.\n";


    if (errorMessage) {
      dialog.alert(message(errorMessage));
      return;
    }

    const result = await this.props.onUserInfoChange(param);
    if (result.status === 200) {
      if (result.data === "NOT_FOUND") {
        dialog.alert(message("현재비밀번호가 일치하지 않습니다."));
        return;
      }
      if (result.data === "DUPLICATED") {
        dialog.alert(message("현재비밀번호와 신규 비밀번호가 같습니다."));
        return;
      }
      if (result.data === "OK") {
        notification(message("변경되었습니다."));
        return;
      }
    }
  }

  onChange(e, data) {
    this.setState({[data.name]: data.value});
  }

  handleClickUploadBtn() {
    this.uploadInputRef.current.click();
  }

  // tab content - 프로필 수정
  tabContent01 = () => {
    Common.InitUtil.init("o10g014112");

    return (
      <>
        <ul className="editProfile">
          <li style={{borderRadius: "50%", overflow: "hidden"}}>
            {this.state.profileImg &&
              <img
                src={this.state.profileImg.includes(`res/media`) ? this.state.profileImg : `o10g01-invcommon/aws/profile/${this.state.profileImg}`}/>
            }
          </li>
          <div/>
          {/*/!*이미지 불러오기 버튼*!/*/}
          {this.state.isPoscoUser && <li className="addProfile" onClick={this.handleClickUploadBtn}/>}
        </ul>
        <ul className="editProfile">
          {
            this.state.profileList.map(props => (
              <li key={`pf${props.id}`}>
                <div className={this.state.profileImg === props.img ? "inUse active" : "inUse"}>
                  <div>사용중<img src={checkIcon}/></div>
                </div>
                <div className="selected">
                  <div onClick={(e) => {
                    this.onClickProfileImg(props);
                  }}>선택하기<img src={checkIcon}/></div>
                </div>
                <img className={props.name}
                     src={props.img.includes(`res/media`) ? props.img : `o10g01-invcommon/aws/profile/${props.img}`}/>
              </li>
            ))
          }

        </ul>
        {/*이미지 추가용 input*/}
        <input type="file"
               name="file"
               accept="image/*"
               ref={this.uploadInputRef}//ref로 input안에 있는 event를 전해줌(current)
               style={{display: "none"}}
               onChange={(event) => this.handleChangeUploadFile(event)}
               multiple={false}
               id="fileUpload"
        />
      </>
    );
  };

  async onClickProfileImg(props) {
    const result = await this.props.onSelectProfileImg(props.img);
    if (result.status === 200) {
      this.props.onUserInfoFind();
    }
  }

  render() {
    return (
      <Modal key={`profile`} size={"small"} open={this.props.open} draggable className="profilePop"
             onClose={this.props.openToggle}>
        <Modal.Header content="사용자정보 변경"/>
        <Modal.Content>
          <section className="o10g014112 popupTab">
            <Tab panes={this.state.isPoscoUser ? this.state.tabInfo : this.state.tabInfo2} onChange={this.onTabChange}/>
          </section>
        </Modal.Content>
        {this.state.activeIndex === 0 ?
          <Modal.Actions
            closeButton={<Button className="btnSec" content="닫기" onClick={this.props.openToggle}/>}
          /> :
          <Modal.Actions
            checkButton={<Button className="btnPrm" content="확인" onClick={this.onUserInfoChange}/>}
            closeButton={<Button className="btnSec" content="취소" onClick={this.props.openToggle}/>}
          />
        }
      </Modal>
    );
  }

  state = {
    profileImg: "",
    profileList: [{id: "1", name: "profile01", img: profileImg01},
      {id: "2", name: "profile02", img: profileImg02},
      {id: "3", name: "profile03", img: profileImg03},
      {id: "4", name: "profile04", img: profileImg04}],
    profile: "",
    //포스코유저
    tabInfo: [
      {menuItem: "프로필 수정", render: () => <Tab.Pane>{this.tabContent01()}</Tab.Pane>}
    ],
    //사외유저
    tabInfo2: [
      {menuItem: "프로필 수정", render: () => <Tab.Pane>{this.tabContent01()}</Tab.Pane>},
      {menuItem: "사용자정보변경", render: () => <Tab.Pane>{this.tabContent02()}</Tab.Pane>}
    ],
    activeIndex: 0
  };

  // tab content - 사용자정보 변경
  tabContent02 = () => {
    Common.InitUtil.init("o10g014112");

    return (
      <>
        <h3>운영지침</h3>
        <div className="textBoxWrap mgt-12">
          <p>변경주기 : 90일(정기적으로 변경하여 사용바랍니다.)</p>
          <p>비밀번호 구성</p>
          <div>
            <p>
              1. 영대문자, 영소문자, 숫자, 특수문자 중 3종류 이상 혼용하여 조합한 8자리 이상 16자리 이하로 설정
              <br/><span>*특수문자(&#126;,&#33;,&#35;,&#36;,&#37;,&#94;,&amp;,&lt;,&#42;등)</span>
            </p>
            <p>2. 직번, ID, 전화번호 사용불가</p>
            <p>3. 3자리 이상 같은 숫자나 문자 연속 사용불가</p>
            {/*TODO 잘알려진 단어 리스트 현업 확인중*/}
            {/*<p>*/}
            {/*  4. 잘 알려진 단어(love, happy, posco 등) 사용불가*/}
            {/*  <br/><span>*바른 사용 예시 : weiSd59, 48*thdwS, cG37hkiel</span>*/}
            {/*</p>*/}
          </div>
        </div>
        {/*<span className="Table_redB">*붉은색으로 표시된 항목은 반드시 입력해야 합니다.</span>*/}
        <div className="gridRow twoColumn mgt-24">
          <div className="gridColumn">
            <div className="h4wrap">
              <h4>아이디</h4>
            </div>
            <div className="srcWrap">
              <Input type="text" value={this.state.smrtNoteUserId} disabled/>
            </div>
          </div>
          <div className="gridColumn">
            <div className="h4wrap">
              <h4>현재 비밀번호</h4>
            </div>
            <div className="srcWrap">
              {/*구글 아이디비밀번호 자동완성 방지용 가짜 input*/}
              <input type="text" style={{position: "absolute", right: 999999999}}/>
              <input type="password" style={{position: "absolute", right: 999999999}}/>
              <Input type="password" className="req-value" name={"password"} onChange={this.onChange}
                     value={this.state.password}/>
            </div>
          </div>
        </div>
        <div className="gridRow twoColumn">
          <div className="gridColumn">
            <div className="h4wrap">
              <h4>전화번호 변경</h4>
            </div>
            <div className="srcWrap">
              <Input type="text" name={"workTelephone"} onChange={this.onChange} value={this.state.workTelephone}/>
            </div>
          </div>
          <div className="gridColumn">
            <div className="h4wrap">
              <h4>신규 비밀번호</h4>
            </div>
            <div className="srcWrap">
              <Input type="password" name={"newPassword"} onChange={this.onChange} value={this.state.newPassword}/>
            </div>
          </div>
        </div>
        <div className="gridRow twoColumn">
          <div className="gridColumn">
            <div className="h4wrap">
              <h4>이메일 변경</h4>
            </div>
            <div className="srcWrap">
              <Input type="text" name={"emailAddress"} onChange={this.onChange} value={this.state.emailAddress}/>
            </div>
          </div>
          <div className="gridColumn">
            <div className="h4wrap">
              <h4>신규 비밀번호 확인</h4>
            </div>
            <div className="srcWrap">
              <Input type="password" name={"checkPassword"} onChange={this.onChange} value={this.state.checkPassword}/>
            </div>
          </div>
        </div>
      </>
    );
  };

  init() {
    this.setState({...this.props.userInfo}, () => {
      //경로에 res/media가 포함되어있지않으면 직접 첨부한 이미지이므로 프로필 리스트에 추가
      if (this.props.userInfo.profile) {
        this.setState({profileImg: ""}, () => {
          this.setState({profileImg: this.props.userInfo.profile});
        });
      }
    });
  }


}

export default o10g014112View;
